var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "landing-cnt row" }, [
    _c("div", { staticClass: "bg-image" }),
    _vm._v(" "),
    _c("div", { staticClass: "col-12 d-xl-none d-lg-flex main-block-xs" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-block-ctn col-xl-6 col-12 d-flex my-auto" },
      [
        _c(
          "div",
          { staticClass: "text-ctn my-auto" },
          [
            _c("h3", [_vm._v(_vm._s(_vm.$t("aca-error-title-page")))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("aca-error-detail-page")))]),
            _vm._v(" "),
            _c(
              "base-button",
              { staticClass: "mt-5", on: { click: _vm.$helpers.gotoACAUrl } },
              [_vm._v(_vm._s(_vm.$t("retry")) + "\n      ")]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6d214d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6d214d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/openlegal/OpenlegalACAError.vue
// module id = 4127
// module chunks = 91